import React from "react";

export default () => {
    return <i className="sprite sprite-toggle-hierarchy" />;
};
